import { Link } from 'react-router-dom'
import '../styles/components/entity-card.css'

/**
 * Универсальная карточка сущности (модель, конфиг и т.д.).
 * Заголовок + badge + иконки действий.
 *
 * @param {Object} props
 * @param {string|React.ReactNode} props.title
 * @param {string} [props.titleHref] — ссылка на заголовок
 * @param {React.ReactNode} [props.leading] — контент перед заголовком (например, AccountUsageIndicator)
 * @param {React.ReactNode} [props.badge]
 * @param {Array<{icon: React.ReactNode, title: string, onClick?: () => void, href?: string, variant?: 'default'|'accent'|'danger'}>} [props.actions]
 * @param {React.ReactNode} [props.children] — тело карточки
 * @param {boolean} [props.active]
 * @param {string} [props.className]
 */
export default function EntityCard({ title, titleHref, leading, badge, actions = [], children, active, className = '' }) {
  const cardClass = ['entity-card', active && 'entity-card--active', className].filter(Boolean).join(' ')

  return (
    <div className={cardClass}>
      <div className="entity-card-header">
        <div className="entity-card-main">
          {leading && <span className="entity-card-leading">{leading}</span>}
          {titleHref ? (
            <Link to={titleHref} className="entity-card-title entity-card-title-link">
              {title}
            </Link>
          ) : (
            <span className="entity-card-title">{title}</span>
          )}
          {badge && <span className="entity-card-badge">{badge}</span>}
        </div>
        {actions.length > 0 && (
          <div className="entity-card-actions">
            {actions.map((action, idx) => {
              const variantClass = action.variant === 'danger' ? 'entity-card-icon--danger' : action.variant === 'accent' ? 'entity-card-icon--accent' : ''
              const iconClass = `entity-card-icon ${variantClass}`.trim()

              if (action.href) {
                return (
                  <Link
                    key={idx}
                    to={action.href}
                    className={iconClass}
                    title={action.title}
                    aria-label={action.title}
                  >
                    {action.icon}
                  </Link>
                )
              }
              return (
                <button
                  key={idx}
                  type="button"
                  className={iconClass}
                  title={action.title}
                  aria-label={action.title}
                  onClick={action.onClick}
                >
                  {action.icon}
                </button>
              )
            })}
          </div>
        )}
      </div>
      {children && <div className="entity-card-body">{children}</div>}
    </div>
  )
}
